import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d184c16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card sidebar-card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "btn btn-block p-0" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = {
  key: 0,
  class: ""
}
const _hoisted_6 = {
  key: 0,
  class: "selected-vehicle"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Year: ", -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Make: ", -1))
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Model:", -1))
const _hoisted_12 = { key: 2 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Sub Model:", -1))
const _hoisted_14 = { key: 3 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Trim: ", -1))
const _hoisted_16 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!
  const _component_spinner = _resolveComponent("spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("button", _hoisted_3, [
        _createVNode(_component_icon, {
          icon: ['fal', 'car'],
          size: "lg"
        }),
        _createTextVNode(" Vehicle "),
        _createVNode(_component_icon, {
          class: "chevron",
          icon: ['fal', 'chevron-up']
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.displayOwnedVehicle)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.selectedVehicle && _ctx.selectedVehicle.year)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.selectedVehicle.year) + " " + _toDisplayString(_ctx.selectedVehicle.make) + " " + _toDisplayString(_ctx.selectedVehicle.model) + " " + _toDisplayString(_ctx.selectedVehicle.subModel) + " " + _toDisplayString(_ctx.selectedVehicle.trim), 1))
              : (_openBlock(), _createBlock(_component_spinner, {
                  key: 1,
                  "hide-background": true
                }))
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.vehicleToCreate)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                  _createElementVNode("li", null, [
                    _hoisted_7,
                    _createElementVNode("strong", null, _toDisplayString(_ctx.vehicleToCreate.year), 1)
                  ]),
                  (_ctx.vehicleToCreate.make)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                        _hoisted_9,
                        _createElementVNode("strong", null, _toDisplayString(_ctx.vehicleToCreate.make), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.vehicleToCreate.model)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                        _hoisted_11,
                        _createTextVNode(),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.vehicleToCreate.model), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.vehicleToCreate.engine)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                        _hoisted_13,
                        _createTextVNode(),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.vehicleToCreate.subModel), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.vehicleToCreate.trim)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                        _hoisted_15,
                        _createElementVNode("strong", null, _toDisplayString(_ctx.vehicleToCreate.trim), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_16, "No vehicle data entered."))
          ], 64))
    ])
  ]))
}